module.exports = __webpack_public_path__ + "img/8. PHONE MOUNT.jpg";